export const TOO_MANY_LINES_ENTERED_MESSAGE =
  'You have entered too many lines of text to fit accurately on this product. Please reduce the number of lines to continue.';
export const TOO_LONG_TEXT_ENTERED_MESSAGE =
  'The text that you entered is too long to fit accurately on this product. Please review the text that is highlighted and reduce the number of characters to continue.';
export const defaultDigitalTextColor = {
  cmyk: '0 0 0 100',
  colorId: 'BLK',
  colorReference: '000000',
  colorType: 1,
  colorDescription: 'Black',
};
export const textStyleIconStatus = {
  Unactivated: 0,
  Activated: 1,
  Disabled: 2,
  ActivatedDisabled: 3,
};
export const outlineThicknessOption = {
  None: 0,
  Thin: 1,
  Medium: 2,
  Wide: 3,
};
export const outlineThicknessList = [
  { label: 'None', value: outlineThicknessOption.None },
  { label: 'Thin', value: outlineThicknessOption.Thin },
  { label: 'Medium', value: outlineThicknessOption.Medium },
  { label: 'Wide', value: outlineThicknessOption.Wide },
];
export const updatePreviewBtnStatus = {
  UpdatePreview: 'Update Preview',
  UpdatingPreview: 'Updating Preview',
  PreviewUpdated: 'Preview Updated',
};

export const SpecialCharacters = [
  '•',
  '™',
  '©',
  '®',
  '¢',
  '£',
  '¤',
  '¥',
  '§',
  '¬',
  '°',
  '±',
  'µ',
  '¶',
  '×',
  '¦',
  '¡',
  'Ø',
  'Þ',
  'ß',
  '÷',
  'À',
  'Á',
  'Ã',
  'Ä',
  'Ç',
  'ç',
  'È',
  'É',
  'Ë',
  'Ì',
  'Í',
  'Ï',
  'Ñ',
  'Ò',
  'Ó',
  'Õ',
  'Ö',
  'Ù',
  'Ú',
  'Ü',
  'à',
  'á',
  'ã',
  'ä',
  'è',
  'é',
  'ë',
  'ì',
  'í',
  'ï',
  'ñ',
  'ò',
  'õ',
  'ö',
  'ù',
  'ú',
  'ü',
  'ý',
  'ÿ',
];
